import React, { useState } from "react";
import Joyride from "react-joyride";
import ReactModal from "react-modal";
import { Howl } from "howler";

const HowPlay = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const steps = [
    {
      target: ".step1",
      content: "Aqui está o botão de início, clique nele para começar.",
    },
    {
      target: ".step2",
      content: "Este é o seu avatar. Personalize-o para começar a jogar!",
    },
    {
      target: ".step3",
      content: "Aqui você pode ver sua pontuação e progresso.",
    },
    {
      target: ".step4",
      content: "Clique aqui para ver os desafios disponíveis.",
    },
  ];

  const playAudio = () => {
    const sound = new Howl({
      src: ["audio/intro.mp3"], // Adicione o caminho do áudio
    });
    sound.play();
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      {/* Áudio de introdução */}
      <button onClick={playAudio}>Ouvir explicação do jogo</button>

      {/* Joyride Tutorial */}
      <Joyride steps={steps} continuous showSkipButton />

      {/* Página do tutorial */}
      <div className="tutorial-container">
        <h1>Como Jogar</h1>

        <div className="step1">
          <p>Botão de início</p>
        </div>

        <div className="step2">
          <p>Avatar</p>
        </div>

        <div className="step3">
          <p>Pontuação e progresso</p>
        </div>

        <div className="step4">
          <p>Desafios</p>
        </div>

        {/* Modal explicativo */}
        <button onClick={openModal}>Ver explicação completa</button>

        <ReactModal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          contentLabel="Tutorial Modal"
          className="modal"
        >
          <h2>Como jogar</h2>
          <p>Este é o seu avatar. Personalize-o para jogar!</p>
          <p>Este é o seu progresso...</p>
          <button onClick={closeModal}>Fechar</button>
        </ReactModal>
      </div>
    </div>
  );
};

export default HowPlay;
